import { render } from "./SettingsPayments.vue?vue&type=template&id=e2600828"
import script from "./SettingsPayments.vue?vue&type=script&lang=js"
export * from "./SettingsPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__